import kv from "@/sy/app.kv.js";
import ajax from "@/sy/app.ajax.js";
import date from "@/sy/app.date.js";
import http from "@/sy/app.http.js";
import region from "@/sy/app.region.js";
import filechunk from "@/sy/app.filechunk.js";

let sy = {
	kv: kv,
	ajax: ajax,
	date: date,
	http: http,
	region: region,

	filechunk: filechunk,
	
	log: function(i) {
		console.log(i);
	},
	
};

export default sy;